import React from 'react';
import TanningServices from './tanning';
import Prices from './prices';
import Resources from './resources';
import LegalCompliance from './legalCompliance';
import PrivacyPolicy from './privacyPolicy';
import Forms from './forms';
import ProtectedRoutes from '../../../components/security';
import { RoleIds } from '../../../models';
import SubHeader from '../../../components/subheader';

export const RootRoutesConfig = [
    {
        path: '/tanning-services',
        main: TanningServices,
        access: RoleIds.ALL,
    },
    {
        path: '/prices',
        main: Prices,
        access: RoleIds.ALL,
    },
    {
        path: '/resources',
        main: Resources,
        access: RoleIds.ALL,
    },
    {
        path: '/legal-compliance',
        main: LegalCompliance,
        access: RoleIds.ALL,
    },
    {
        path: '/privacy-policy',
        main: PrivacyPolicy,
        access: RoleIds.ALL,
    },
    {
        path: '/forms',
        main: Forms,
        access: RoleIds.ALL,
    },
];

function PublicRoutes() {
    return (
        <>
            <SubHeader />
            <div className="page-content">
                <div className="container">
                    <div className="content">
                        <ProtectedRoutes routes={RootRoutesConfig} />
                    </div>
                </div>
            </div>
        </>
    );
}

export default PublicRoutes;
